var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirplaneMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.49688 9.43548L6.12638 7.83494C6.56763 7.56678 6.78827 7.43269 6.94057 7.24879C7.59969 6.45289 7.01926 5.27737 7.11754 4.35184C7.21928 3.39381 8.13286 2.08349 9.05381 1.67727C9.33723 1.55224 9.66236 1.55224 9.94578 1.67727C10.8667 2.08349 11.7803 3.39381 11.882 4.35184C11.9804 5.27737 11.3999 6.45289 12.0591 7.24879C12.2113 7.43269 12.4319 7.56678 12.8732 7.83494L15.503 9.4354C16.3078 9.92521 16.6248 10.448 16.6248 11.4314C16.6248 11.9667 16.388 12.1101 15.9104 12.0009L11.2991 10.9458L11.092 12.7578C11.0169 13.4148 10.9794 13.7433 11.0879 14.0442C11.3422 14.7489 12.2054 15.3261 12.7325 15.8387C13.0239 16.122 13.3419 16.9366 13.0097 17.307C12.8046 17.5358 12.4714 17.3501 12.2421 17.2609L10.0344 16.4022C9.77043 16.2995 9.63838 16.2482 9.49983 16.2482C9.36121 16.2482 9.22916 16.2995 8.96522 16.4022L6.75753 17.2609C6.52823 17.3501 6.19505 17.5358 5.98994 17.307C5.65772 16.9366 5.97569 16.122 6.26705 15.8387C6.79423 15.3261 7.65743 14.7489 7.91167 14.0442C8.02021 13.7433 7.98268 13.4148 7.90761 12.7578L7.70056 10.9458L3.08954 12.0008C2.61172 12.1101 2.37485 11.9666 2.375 11.4311C2.37526 10.4479 2.69221 9.92529 3.49688 9.43548Z",
    stroke: "#003371",
    strokeWidth: 1.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplaneMode);
export default __webpack_public_path__ + "static/media/airplane-mode.afc3487907e8c9ee462abfe43a4b9c26.svg";
export { ForwardRef as ReactComponent };